export default {
	name: 'testimonialsSection',
	title: 'Testimonials Section',
	type: 'object',
	fields: [
		{
			name: 'title',
			title: 'Section Title',
			type: 'string',
		},
		{
			name: 'subtitle',
			title: 'Section Subtitle',
			type: 'text',
		},
		{
			name: 'testimonials',
			title: 'Testimonials',
			type: 'array',
			of: [
				{
					type: 'testimonial',
				},
			],
		},
	],
};
